import { useEffect, useState } from "react";

// nextStart: "HH:MM" (today, local)
function toNextDate(startHHMM) {
  const [h, m] = startHHMM.split(":").map(Number);
  const now = new Date();
  const d = new Date(now);
  d.setHours(h, m, 0, 0);
  if (d.getTime() <= now.getTime()) d.setDate(d.getDate() + 1);
  return d;
}

function fmt(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const hh = String(Math.floor(s / 3600)).padStart(2, "0");
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return { hh, mm, ss };
}

export default function CountdownBadge({ start, size = "md" }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const target = toNextDate(start);
  const { hh, mm, ss } = fmt(target - now);
  const cls =
    size === "lg"
      ? "font-mono text-5xl sm:text-6xl tracking-tight text-stone-900"
      : "font-mono text-sm tracking-tight text-stone-700";
  return (
    <span className={cls} data-testid="countdown-badge">
      {hh}<span className="animate-pulse-slow">:</span>{mm}<span className="animate-pulse-slow">:</span>{ss}
    </span>
  );
}
